<template>
  <div class="ad-group-wrap">
    <div class="card-header">广告计划</div>
    <div class="newgroup-wrap" style="padding-top: 20px">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="ruleForm">
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">营销目标：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.flag">
                <el-radio label="app">提升应用安装</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 0px">广告计划：</span>
            <div class="form-value">
              <el-radio-group
                v-model="formData.campaign_type"
                @change="queryPlanList()"
              >
                <el-radio :label="2">新建广告计划</el-radio>
                <el-radio :label="1">已有广告计划</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li v-if="formData.campaign_type == 1" class="form-item">
            <span class="form-label" style="padding-top: 0px"></span>
            <div class="form-value">
              <el-form-item prop="selectPlan">
                <el-select
                  v-model="formData.selectPlan"
                  placeholder="请选择已有广告计划"
                  style="width: 300px"
                  popper-class="count-select"
                >
                  <el-option
                    v-for="item of planList"
                    :key="item.campaignId"
                    :label="item.campaignName + '(' + item.campaignId + ')'"
                    :value="item.campaignId"
                  >
                    <div class="count-option">
                      <span class="count-item">{{ item.campaignName }}</span>
                      <span class="count-item">ID：{{ item.campaignId }}</span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </li>
          <div v-else>
            <li class="form-item">
              <span class="form-label">广告计划名称：</span>
              <div class="form-value">
                <select-input
                  ref="selectInputRef"
                  :dataList="adGroupList"
                  v-model="formData.name_rule"
                ></select-input>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">预算：</span>
              <div class="form-value">
                <el-radio-group
                  v-model="formData.budget_mode"
                  @change="renderRule()"
                >
                  <el-radio label="BUDGET_MODE_INFINITE">不限</el-radio>
                  <el-radio label="BUDGET_MODE_DAY">统一预算</el-radio>
                  <el-radio label="BUDGET_MODE_DAY_SCHEDULE">分日预算</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li
              v-if="formData.budget_mode === 'BUDGET_MODE_DAY'"
              class="form-item"
              style="margin-bottom: 0px"
            >
              <span class="form-label">统一预算：</span>
              <div class="form-value">
                <el-form-item prop="day_budget">
                  <el-input
                    style="width: 264px"
                    placeholder="不小于500，仅支持整数"
                    v-model="formData.day_budget"
                  >
                    <template slot="append">CNY</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>
            <li
              v-if="formData.budget_mode === 'BUDGET_MODE_DAY_SCHEDULE'"
              class="form-item"
              style="margin-bottom: 0px"
            >
              <span class="form-label">分日预算：</span>
              <div class="form-value">
                <el-form-item prop="weekData">
                  <ul class="week-wrap">
                    <li
                      class="week-item"
                      v-for="item of formData.weekData"
                      :key="item.lable"
                    >
                      <div class="week-label">{{ item.lable }}</div>
                      <div class="week-value">
                        <input
                          class="week-input"
                          v-model="item.value"
                          type="text"
                          placeholder="不限"
                          @input="renderRule()"
                        />
                      </div>
                    </li>
                  </ul>
                </el-form-item>
              </div>
            </li>
          </div>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getCampaignList } from "@/api/promotion-kuaishou.js";
import nameTransforUtil from "./common/nameTransforUtil.js";
import SelectInput from "./common/selectInput.vue";
export default {
  components: {
    SelectInput,
  },
  data() {
    return {
      showHasModal: false,
      adGroupList: [
        "营销目标",
        "应用名称",
        "应用标记",
        "创建日期",
        "预算类型",
        "广告位置",
        "转化跟踪名称",
        "首个视频名称",
      ],
      rules: {
        selectPlan: [
          {
            required: true,
            message: "请选择广告计划",
            trigger: ["blur", "change"],
          },
        ],
        day_budget: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === null || value === "") {
                callback(new Error("统一预算必填"));
              } else if (
                !/^[1-9]*[1-9][0-9]*$/.test(value) ||
                Number(value) < 500
              ) {
                callback(new Error("请输入不小于500的整数"));
              } else {
                callback();
              }
            },
          },
        ],
        weekData: [
          {
            trigger: ["blur", "change"],
            type: "arr",
            validator: (rule, value, callback) => {
              for (let i = 0; i < value.length; i++) {
                let curItem = value[i];
                if (!curItem.value) {
                  callback(new Error("分日预算填写不完整"));
                  break;
                } else if (
                  !/^[1-9]*[1-9][0-9]*$/.test(curItem.value) ||
                  Number(curItem.value) < 500
                ) {
                  callback(new Error("请输入不小于500的整数"));
                  break;
                }
              }
              callback();
            },
          },
        ],
      },
      formData: {
        flag: "app",
        campaign_type: 2,
        name_rule: "",
        budget_mode: "BUDGET_MODE_INFINITE",
        day_budget: null,
        weekData: [
          { lable: "星期一", value: "" },
          { lable: "星期二", value: "" },
          { lable: "星期三", value: "" },
          { lable: "星期四", value: "" },
          { lable: "星期五", value: "" },
          { lable: "星期六", value: "" },
          { lable: "星期日", value: "" },
        ],
        selectPlan: null,
      },
      planList: [],
    };
  },
  methods: {
    queryPlanList(pathData) {
      let campaign_type = this.formData.campaign_type;
      this.$store.commit("set_plan_type_k", campaign_type); //联动规则
      if (campaign_type === 1) {
        getCampaignList({
          advertiserId: this.adCount.advertiserId,
        }).then((res) => {
          if (res.code === "0000") {
            this.planList = res.campaignInfos;
            if (pathData) {
              this.formData.selectPlan = pathData;
            }
          }
        });
      }
    },

    checkData() {
      return Promise.all([
        this.$refs.selectInputRef
          ? this.$refs.selectInputRef.checkData()
          : Promise.resolve(),
        new Promise((resolve, reject) => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              let parmas = null;
              if (this.formData.campaign_type === 2) {
                //保存新建到store
                parmas = {
                  advertiser_id: this.adCount.advertiserId,
                  campaign_type: this.formData.campaign_type,
                  budget_mode: this.formData.budget_mode,
                  day_budget:
                    this.formData.budget_mode === "BUDGET_MODE_DAY"
                      ? this.formData.day_budget * 1000
                      : 0,
                  day_budget_schedule:
                    this.formData.budget_mode === "BUDGET_MODE_DAY_SCHEDULE"
                      ? this.formData.weekData.map((item) =>
                          item.value ? parseFloat(item.value) * 1000 : 0
                        )
                      : [0, 0, 0, 0, 0, 0, 0],
                  name_rule: nameTransforUtil.showDataToApi(
                    this.formData.name_rule
                  ),
                };
              } else {
                //保存已有到store
                let curPlan = this.planList.find(
                  (item) => item.campaignId === this.formData.selectPlan
                );
                parmas = {
                  campaign_type: this.formData.campaign_type,
                  advertiser_id: this.adCount.advertiserId,
                  campaign_id: this.formData.selectPlan,
                  budget_mode: curPlan ? curPlan.budgetMode : null,
                  day_budget: curPlan ? curPlan.budget : null,
                  day_budget_schedule: curPlan.budgetSchedule || [
                    0, 0, 0, 0, 0, 0, 0,
                  ],
                  name_rule: curPlan ? curPlan.campaignName : null,
                };
              }
              this.$store.commit("set_draft_campaign_k", parmas);
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
    renderRule() {
      this.$refs.ruleForm.validate();
    },
    renderStoreData(storeData) {
      this.formData.campaign_type = storeData.campaign_type;
      if (storeData.campaign_type === 2) {
        //新建格式
        this.formData.budget_mode = storeData.budget_mode;
        this.formData.day_budget = storeData.day_budget / 1000 || 0;
        storeData.day_budget_schedule.forEach((item, index) => {
          this.formData.weekData[index].value = item / 1000;
        });
        this.formData.name_rule = nameTransforUtil.apiDatatoShow(
          storeData.name_rule
        );
      } else {
        //已有格式
        this.queryPlanList(storeData.campaign_id);
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionKuaishou.adCount,
      draft_campaign: (state) => state.PromotionKuaishou.draft_campaign,
    }),
  },
  watch: {
    draft_campaign(value) {
      if (value) {
        this.renderStoreData(value);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ad-group-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .btn-group {
    margin-top: 16px;
    .def-btn {
      color: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .newgroup-wrap {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        /deep/ .el-form-item {
          margin-bottom: 6px;
        }
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 100px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 6px;
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .week-wrap {
            padding: 0px;
            margin: 0px;
            list-style: none;
            border: 1px solid rgb(238, 238, 238);
            display: flex;
            width: 616px;
            height: 70px;
            .week-item {
              display: inline-block;
              width: 88px;
              border-right: 1px solid rgb(238, 238, 238);
              .week-label {
                height: 32px;
                line-height: 32px;
                text-align: center;
                font-size: 12px;
                background-color: #f7f7f7;
              }
              .week-value {
                height: 32px;
                .week-input {
                  width: 100%;
                  height: 100%;
                  box-sizing: border-box;
                  outline: none;
                  text-align: center;
                  border: none;
                }
              }
            }
            .week-item:last-child {
              border-right: none;
            }
          }
          .count-select {
            .el-select-dropdown__item {
              height: 45px;
              line-height: 45px;
            }
            .count-option {
              font-size: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              height: 100%;
              .count-item {
                display: block;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>